import styled from 'styled-components'

const Logo = styled.svg`
    display: block;
    height: 34px;
    left: 15px;
    position: absolute;
    top: 15px;
`

const Video404Header = () => (
    <Logo xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164 35">
        <g fill="none" fillRule="evenodd">
            <g fill="#FFF" fillRule="nonzero">
                <path d="M149.427 13.3l5.84-9.333h8.636v.35l-10.77 16.002V31.15h-7.665V20.32L135.165 4.277v-.311h8.635zM125.249 31.189V20.903h-9.76v10.286h-7.666V4.006h7.665V14.33h9.76V4.006h7.588v27.183zM88.593 23.82v7.33h-7.665V3.967h13.176c7.277 0 10.886 4.589 10.886 9.897 0 5.561-3.648 9.858-10.886 9.936h-5.51v.02zm0-6.495h5.511c2.135 0 3.221-1.556 3.221-3.344 0-1.79-1.125-3.423-3.221-3.423h-5.51v6.767zM68.567 31.15V3.967h7.626V31.15h-7.626zM59.389 12.017c-1.98-1.867-4.386-2.373-6.19-2.373-4.424 0-7.277 2.645-7.277 7.953 0 3.5 1.824 7.797 7.277 7.797 1.436 0 3.687-.272 5.24-1.4v-3.5h-6.85v-6.008h13.253v12.075c-1.708 3.461-6.423 5.328-11.663 5.328-10.73 0-14.805-7.175-14.805-14.292 0-7.097 4.657-14.408 14.844-14.408 3.765 0 7.083.778 10.653 4.394l-4.482 4.434z" />
            </g>
            <path d="M23.286 11.667h3.88V31.11h-3.88z" fill="#93F" />
            <path d="M0 31.111h27.167v3.89H0z" fill="#0CF" />
            <path d="M0 3.889h3.881V31.11H0z" fill="#0F9" />
            <path d="M0 0h15.524v3.889H0z" fill="#FFF35C" />
            <path d="M23.286 7.778v-3.89h-3.881V0h-3.881v11.667h11.642v-3.89z" fill="#F66" />
            <path d="M15.524 0v3.889h-3.881zM23.286 15.594v-3.927h3.88z" fill="#0F0F0F" opacity=".4" />
        </g>
    </Logo>
)

export default Video404Header
